if(!customElements.get('custom-logo-list')){
 
    class CustomLogoList extends HTMLElement {
        constructor(){
            super();
    
            this.swiperContainer = this.querySelector('.swiper-container');
            this.initSwiper();
        }
    
        initSwiper(){
            var totalSlides = parseInt(this.swiperContainer.dataset.totalSlides);
            var numPerView = parseInt(this.swiperContainer.dataset.numPerView);
            var slidesPerView = (numPerView && totalSlides > numPerView)? numPerView : totalSlides;
    
            var loop = (this.swiperContainer.dataset.loop == 'true')? true : false;
    
            var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: loop,
                spaceBetween: 30,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: {
                    0: { slidesPerView: slidesPerView < 1? slidesPerView : 1 },
                    576: {
                        slidesPerView: slidesPerView < 3? slidesPerView : 3
                    },
                    991: {
                        slidesPerView: slidesPerView < 5? slidesPerView : 5
                    },
                    1200: {
                        slidesPerView: slidesPerView < 8? slidesPerView : 8
                    }
                },
                observer: true,
                observeSlideChildren: true
            }
    
            if(this.swiperContainer.querySelector('.swiper-pagination')){
                swiperSettings.pagination = {
                    el: this.querySelector('.swiper-pagination')
                }
            }
    
            if(this.swiperContainer.querySelector('.swiper-button-next')){
                swiperSettings.navigation = {
                    nextEl: this.querySelector('.swiper-button-next'),
                    prevEl: this.querySelector('.swiper-button-prev')
                }
            }
    
            if(this.swiperContainer.dataset.autoplay == 'true'){
                let speed = this.swiperContainer.dataset.speed;
                speed = parseInt(speed) * 1000;
                swiperSettings.autoplay = {
                    delay: speed
                }
            }
    
            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.swiper.init();
            this.getVisibleSlides();
            this.checkPagination();

            this.swiper.on('slideChange', () => {
                this.getVisibleSlides();
            });
    
            this.swiper.on('resize' ,() => {
                this.checkPagination();
            });

            this.swiper.on('breakpoint', () => {
                this.checkPagination();
            });
        }

        getVisibleSlides(){
            if(this.swiper){
                const allSlides = this.swiper.slides;
                const activeIndex = this.swiper.activeIndex;
                const slidesPerView = this.swiper.params.slidesPerView;

                const visibleSlides = [];
                
                if(slidesPerView === 'auto'){
                    allSlides.forEach((slide) => {
                        const rect = slide.getBoundingClientRect();
                        if (rect.left >= 0 && rect.right <= window.innerWidth) {
                            visibleSlides.push(slide);
                        }
                    });
                }else{
                    for (let i = activeIndex; i < activeIndex + slidesPerView && i < allSlides.length; i++) {
                        visibleSlides.push(allSlides[i]);
                    }
                }
    
                allSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '-1');
                    });
                });
    
                visibleSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '0');
                    });
                });
            }
        }

        checkPagination(){
            var pagination = this.querySelector('.swiper-pagination');
            var btns = {
                prev: this.querySelector('.swiper-button-prev'),
                next: this.querySelector('.swiper-button-next')
            }
            // In loop mode Swiper renders one bullet per logo even when all logos fit on screen.
            var allSlidesVisible = parseInt(this.swiperContainer.dataset.totalSlides) <= this.swiper.params.slidesPerView;
            if(pagination && (allSlidesVisible || pagination.querySelectorAll('.swiper-pagination-bullet').length <= 1)){
                pagination.classList.add('d-none');
                if(btns.prev) btns.prev.style.display = 'none';
                if(btns.next) btns.next.style.display = 'none';
            }else{
                if(pagination) pagination.classList.remove('d-none');
                if(btns.prev) btns.prev.style.display = 'block';
                if(btns.next) btns.next.style.display = 'block';
            }
        }

        refresh(){
            this.initSwiper();
        }
    }
    
    customElements.define('custom-logo-list', CustomLogoList);
}